<template>
	<div class="root">
		<div class="banner">
			<div class="nav-box">
				<div class="nav"><a href="/"></a></div>
			</div>
		</div>
		<div class="access">
			<div class="access-content">
				<div class="title">
					<img src="./festival/word-ACCESS-ALL.png" alt="ACCESS-ALL">
				</div>
				<div class="small-icon">
					<img src="./festival/icon-tail.png" alt="icon">
				</div>
				<div class="summary">
					<span>三大品类</span><span>快速办理</span><span>先用后付</span>
				</div>
				<ul class="category">
					<li>
						<p class="top station"><span>园区工位</span></p>
						<p class="down">园区工位</p>
					</li>
					<li class="has-margin">
						<p class="top member"><span>漫游会员</span></p>
						<p class="down">漫游会员</p>
					</li>
					<li>
						<p class="top election"><span>八戒严选</span></p>
						<p class="down">八戒严选</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="special-offer">
			<div class="special-offer-content">
				<div class="title">
					<img src="./festival/word-SPECIAL-OFFER.png" alt="word-SPECIAL-OFFER">
				</div>
				<div class="small-icon">
					<img src="./festival/icon-tail.png" alt="icon">
				</div>
				<ul class="offer-item">
					<li>
						<div class="icon">
							<img src="./festival/icon-service.png" alt="service">
						</div>
						<div class="words">
							<h2>免费服务</h2>
							<p>专业咨询免费提供</p>
						</div>
					</li>
					<li class="deviation">
						<div class="icon">
							<img src="./festival/icon-handle.png" alt="service">
						</div>
						<div class="words">
							<h2>在线办理</h2>
							<p>最快30分钟内完成审批放款</p>
						</div>
					</li>
					<li>
						<div class="icon">
							<img src="./festival/icon-flexible.png" alt="service">
						</div>
						<div class="words">
							<h2>期数灵活</h2>
							<p>3期、6期、12期按需选择</p>
						</div>
					</li>
					<li class="deviation">
						<div class="icon">
							<img src="./festival/icon-quota.png" alt="service">
						</div>
						<div class="words">
							<h2>额度更高</h2>
							<p>1000到10万都能分期</p>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="contact-us">
			<div class="contact-us-content">
				<div class="title">
					<h2>更多联系方式</h2>
				</div>
				<ul class="detail">
					<li class="webchat">
						<p>微信咨询</p>
						<img src="./festival/icon-erweima.png" alt="二维码">
					</li>
					<li class="has-margin phone-mail">
						<p>联系电话</p>
						<h2>023-88392602</h2>
					</li>
					<li class="phone-mail">
						<p>电子邮箱</p>
						<h2>kangkang@zbj.com</h2>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'eight-festival',
	mounted() {
		this.$bus.$emit('ready');
	},
}
</script>
<style lang="less" scoped>
@import "..\..\..\global\css\mixin\mixin.less";
.banner{
	width: 100%;
	height: 1026px;
	background: url('./festival/banner.png') no-repeat center;
	.nav-box{
		width: 100%;
		height: 80px;
		background-color: rgba(21,146,235,.3);
		.nav{
			width: 1200px;
			height: 80px;
			margin: 0 auto;
			position: relative;
			a{
				position: absolute;
				left: 0;
				top: 0;
				width: 134px;
				height: 80px;
				background: url('./festival/icon-logo.png') no-repeat center;
			}
		}
	}
}
.access{
	width: 100%;
	padding: 85px 0px;
	background-color: #f7f7f7;
	.access-content{
		width: 1200px;
		min-height: 400px;
		margin: 0 auto;
		.title{
			img{
				width: 543px;
				height: 91px;
				display: block;
			}
		}
		.small-icon{
			padding: 20px 0px;
			img{
				width: 133px;
				height: 5px;
				display: block;
			}
		}
		.summary{
			width: 100%;
			height: 50px;
			line-height: 50px;
			span{
				padding-left: 32px;
				color: #464E5F;
				font-size: 20px;
				padding-right: 80px;
				background: url('./festival/icon-checked.png')no-repeat left center;
			}
		}
		.category{
			width: 1200px;
			padding-top: 40px;
			height: 338px;
			li{
				width: 370px;
				height:338px;
				border-radius: 5px;
				background-color: #ffffff;
				float: left;
				&.has-margin{
					margin-left: 45px;
					margin-right: 45px;
				}
				p.top{
					width: 370px;
					height:258px;
					span{
						padding-top: 80px;
						padding-left: 50px;
						font-size: 40px;
						color: #F7F7F7;
						display: inline-block;
					}
					&.station{
						background: url('./festival/bg-station.png') no-repeat;
					}
					&.member{
						background: url('./festival/bg-member.png') no-repeat;
					}
					&.election{
						background: url('./festival/bg-election.png') no-repeat;
					}
				}
				p.down{
					width: 370px;
					height:80px;
					text-align: center;
					color: #333333;
					line-height: 80px;
					font-size: 26px;
				}
			}
		}
	}
}
.special-offer{
	width: 100%;
	background-color: #ffffff;
	.special-offer-content{
		width: 1200px;
		height: 500px;
		padding-top: 85px;
		margin: 0 auto;
		.title{
			img{
				width: 360px;
				height: 91px;
				display: block;
			}
		}
		.small-icon{
			padding: 20px 0px;
			img{
				width: 133px;
				height: 5px;
				display: block;
			}
		}
		.offer-item{
			padding-left: 370px;
			height: 352px;
			padding-top:10px;
			li{
				float: left;
				height: 176px;
				width: 415px;
				.icon{
					width: 92px;
					height: 176px;
					float: left;
					img{
						width: 100%;
					}
				}
				.words{
					width: 223px;
					height: 176px;
					float: left;
					padding-left: 30px;
					h2{
						font-size: 32px;
						color: #464E5F;
						height: 45px;
						line-height: 45px;
						font-weight: 900;
					}
					p{
						font-size: 18px;
						color: #999999;
						height: 45px;
						line-height: 45px;
					}
				}
				&.deviation{
					width: 345px;
					padding-left: 70px;
				}
			}
		}
	}
}
.contact-us{
	width: 100%;
	height: 520px;
	background-color: #F7F7F7;
	.contact-us-content{
		width: 1200px;
		height: 520px;
		margin:0 auto;
		.title{
			width: 100%;
			height: 206px;
			background: url('./festival/word-CONTACT-US.png') no-repeat center;
			h2{
				width: 100%;
				height: 100px;
				line-height: 100px;
				background: url('./festival/icon-double-color.png') no-repeat center bottom;
				font-size: 40px;
				color:#464E5F;
				text-align: center;
				padding-top: 60px;
				font-weight: 900;
			}
		}
		.detail{
			width: 1200px;
			height: 218px;
			li{
				width: 340px;
				height: 218px;
				background-color: #ffffff;
				float: left;
				&.has-margin{
					margin-left:90px;
					margin-right: 90px;
				}
				&.webchat{
					text-align: center;
					p{
						color: #464E5F;
						font-size: 24px;
						padding-top:30px;
						padding-bottom: 20px;
					}
					img{
						width: 128px;
						height: 128px;
					}
				}
				&.phone-mail{
					padding-left: 40px;
					width: 300px;
					padding-top: 18px;
					height: 200px;
					color: #464E5F;
					font-size: 24px;
					p{
						height: 55px;
						line-height: 55px;
						background: url('./festival/icon-blue.png') no-repeat left bottom;
					}
					h2{
						height: 130px;
						line-height: 130px;
						font-weight: bold;
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// eightFestival.vue?c3c0f3a4